import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean, NodeData } from "../ds/client_ds.js";
import {
  AttributeCacheBean,
  BankAdjustmentBean,
  BankAdjustmentSearchCriteria,
  PageListBean,
  RestBankAdjustmentBeanRequest,
  RestEntityUnLockRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DatePickerComponent,
  InputTextbox,
  NumberFormatInputbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
} from "../gui_components/Util.js";
import { BankAdjustmentLookupHandler } from "../lookup/BankAdjustmentLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { History, AlignStartVertical } from "lucide-react";
import {
  ApproveIcon,
  CancelIcon,
  UnApproveIcon,
} from "../gui_components/Icons.js";
import CustomTable from "../gui_components/CustomTable.js";

class BankAdjustmentList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      bankList: [],
      isBankAdjustmentListFormOpen: true,
      response: {},
      pageTitle: "Customer",
      modeText: "",
      bankAdjustmentData: new BankAdjustmentBean(),
      pageList: new PageListBean(),
      criteria: new BankAdjustmentSearchCriteria(),
      currentPageNumber: 0,
      totalCount: 0,
      attributeCache: new AttributeCacheBean(),
      companyCode: "",
      isBankAdjustmentEntryFormOpen: false,
      isShowNodes: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      selectedNodeKey: "headerView",
      isBankAdjustmentHistoryFormOpen: false,
      isShowModuleSearchContainer: false,
      bankAdjustmentLookupHandler: null,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      disabled: false,
      isfetched: false,
      adjustmentReasons: [],
      bankCode: [],
      banks: [],
      order: "asc",
      sortField: "",
      statusTracks: [],
      moduleOrderStatus: "",
      isShowApproveButton: true,
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjReasonList: false,
      bankAdjReasonPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      isResetView: true,
      isShowLookup: true,
      isViewMode: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "Bank Adjustment Maintenance";
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    const { cache } = appData;
    this.cache = cache;
    ModuleUtils.getBankAdjustmentStatusList();
    this.loadCacheDetails();
    this.initLookupHandlers();
    this.addNewEntry();
  }
  initLookupHandlers = () => {
    let bankAdjustmentLookupHandler = new BankAdjustmentLookupHandler(
      this.companyCode,
      "BankAdjustment",
    );
    this.setState({
      bankAdjustmentLookupHandler: bankAdjustmentLookupHandler,
    });
  };
  loadCacheDetails = () => {
    const attribute_cache = { ...this.cache };

    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    this.state.adjustmentReasons = [];
    let adjustmentReasons = attribute_cache.bankAdjustmentReasons;
    adjustmentReasons.map((ar) => {
      this.state.adjustmentReasons.push(ar);
    });
    this.state.banks = [];
    let banks = attribute_cache.bankAccounts;
    let bank_temp = [];
    banks.map((bc) => {
      bank_temp.push(bc);
      this.state.banks = ModuleUtils.isActiveAttribute(bank_temp);
    });
  };
  filterBankAdjustment = () => {
    this.loadPage(1);
  };
  resetFilterBankAdjustment = () => {
    let criteria = new BankAdjustmentSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    criteria.specialSearchText = "";
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadBankAdjustmentList();
  };
  loadBankAdjustmentListResponse = (response) => {
    let bankList = [];
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.bankAdjustmentPageList)
    ) {
      bankList = response.data.bankAdjustmentPageList.bankAdjustments;
      this.state.pageList.totalCount =
        response.data.bankAdjustmentPageList.totalCount;
      this.state.pageList.currentPage =
        response.data.bankAdjustmentPageList.currentPage;
    } else {
      bankList = new Array();
    }
    let loading = this.state.isLoading;
    loading = false;
    this.setState({
      isLoading: loading,
      bankList: bankList,
    });
  };
  loadBankAdjustmentListError = (error) => {
    ShowError("Error : " + error);
  };
  loadBankAdjustmentList = () => {
    let requestInput = new RestBankAdjustmentBeanRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.BankAdjustmentView_IsAccessible()) {
      AccountPayableService.getBankAdjustmentPageList(
        requestInput,
        this.loadBankAdjustmentListResponse,
        this.loadBankAdjustmentListError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  addNewEntry = () => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    let bankAdjustmentData = new BankAdjustmentBean();
    let pageTitle = this.moduleCaption + " - NEW";
    bankAdjustmentData.companyCode = this.companyCode;
    bankAdjustmentData.createdDate = currentDate;
    bankAdjustmentData.status = "O";
    if (!isEmptyString(this.state.moduleKeyCode)) {
      bankAdjustmentData.adjustmentNumber = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else bankAdjustmentData.adjustmentNumber = NEW_ENTRY;
    this.setState({
      bankAdjustmentData: bankAdjustmentData,
      statusTracks: new Array(),
      pageTitle: pageTitle,
    });
    this.state.bankAdjustmentData = bankAdjustmentData;
    this.openEntryForm();
  };
  openEntryForm = () => {
    this.closeAllNodeViews();
    let bankAdjustmentData = this.state.bankAdjustmentData;
    this.getNodeList();
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getBankAdjustmentStatusCaption(
      this.state.bankAdjustmentData.status,
    );
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    this.setState({
      isBankAdjustmentListFormOpen: false,
      isBankAdjustmentEntryFormOpen: true,
      isBankAdjustmentHistoryFormOpen: false,
      isShowSaveButton: true,
      isShowApproveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      disabled: false,
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjReasonList: false,
      bankAdjReasonPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      isResetView: true,
    });
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    if (bankAdjustmentData.isFetched) {
      if (bankAdjustmentData.status == "A") {
        this.setState({
          isShowCancelButton: false,
          isShowApproveButton: false,
          isShowClearErrorButton: true,
          isShowSaveButton: false,
        });
      }
      this.setState({ isDisableFields: true, isShowLookup: false });
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        isDisableFields: true,
        disabled: true,
        pageTitle: pageTitle,
      });
    }
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isBankAdjustmentListFormOpen: true,
      isBankAdjustmentEntryFormOpen: false,
      isShowSaveButton: false,
      isShowApproveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      disabled: false,
      isBankAdjustmentHistoryFormOpen: false,
      isShowLookup: true,
      isResetView: false,
      isViewMode: false,
      isDisableFields: false,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isBankAdjustmentListFormOpen: false,
      isBankAdjustmentEntryFormOpen: false,
      isBankAdjustmentHistoryFormOpen: false,
    });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let bankAdjustmentData = this.state.bankAdjustmentData;
    let headerObject = this.getEmptyView();
    let headerNode = new NodeData(
      "headerView",
      "Header",
      headerObject,
      <AlignStartVertical size={16} />,
    );
    let historyNode = new NodeData(
      "historyView",
      "History",
      headerObject,
      <History size={16} />,
    );
    nodeList["headerView"] = headerNode;
    if (bankAdjustmentData.isFetched) nodeList["historyView"] = historyNode;
    this.setState({ nodeList: nodeList });
  };
  unLockBankAdjustment = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.BankAdjustmentMaintenance_IsAccessible()) {
      AccountPayableService.unLockBankAdjustmentNumber(
        request,
        this.unlockBankAdjustmentResponse,
        this.unlockBankAdjustmentError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockBankAdjustmentResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editBankAdjustment(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        this.showErrorMessage(response.data);
      }
    }
  };
  unlockBankAdjustmentError = (error) => {
    ShowError("Error : ", error);
  };
  editBankAdjustment = (code) => {
    this.setState({
      isLoading: true,
    });
    let readrestInput = new RestBankAdjustmentBeanRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    readrestInput.isLoadChildren = true;
    let isLockRequired = NEW_ENTRY === code ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.BankAdjustmentMaintenance_IsAccessible()) {
      AccountPayableService.initBankAdjustmentModule(
        readrestInput,
        this.editBankAdjustmentResponse,
        this.editBankAdjustmentError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      disabled: true,
    });
  };
  editBankAdjustmentResponse = (response) => {
    if (response.data != null) {
      let errMsg = "";
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.errors != null) {
          response.data.mainOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.additionalOperationResponse != null) {
        if (response.data.additionalOperationResponse.errors != null) {
          response.data.additionalOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (
          errMsg !=
          " BankAdjustment Number [" +
            this.state.moduleKeyCode +
            "] Not Read Successfully"
        ) {
          this.showErrorMessage(response.data.mainOperationResponse);
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.bankAdjustmentBean != null) {
          const bankAdjustmentData =
            response.data.mainOperationResponse.bankAdjustmentBean;
          let statusTracks = [];
          statusTracks = bankAdjustmentData.statusTracks;
          let moduleKeyCode = bankAdjustmentData.adjustmentNumber;
          let pageTitle = this.moduleCaption + " - EDIT";

          this.setState({
            bankAdjustmentData: bankAdjustmentData,
            statusTracks: statusTracks,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            isLoading: false,
          }, () => {
            this.openEntryForm();
          });
          this.state.bankAdjustmentData = bankAdjustmentData;
          this.isLocked = true;
          // this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
    }
    this.setState({
      isLoading: false,
    });
  };
  editBankAdjustmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : ", error);
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setBankAdjustmentHeaderView();
    } else if (selectedNode == "historyView") {
      this.setBankAdjustmentHistoryView();
    }
  };
  setBankAdjustmentHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isBankAdjustmentEntryFormOpen: true,
      isBankAdjustmentListFormOpen: false,
      isBankAdjustmentHistoryFormOpen: false,
    });
  };
  setBankAdjustmentHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isBankAdjustmentEntryFormOpen: false,
      isBankAdjustmentListFormOpen: false,
      isBankAdjustmentHistoryFormOpen: true,
    });
  };
  validateBAData = (data) => {
    let bankCode = "";
    this.state.banks
      .filter((bc) => bc.code === data.bankCode)
      .map((list) => {
        bankCode = list.code;
      });
    let adjustmentReason = "";
    this.state.adjustmentReasons
      .filter((bc) => bc.code === data.reasonCode)
      .map((list) => {
        adjustmentReason = list.code;
      });
    let isValidBAData = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.reasonCode)) {
        let errMsg = "Reason is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (!isEmptyString(data.bankCode != bankCode)) {
        let errMsg = "Invalid BankCode";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (!isEmptyString(data.reasonCode != adjustmentReason)) {
        let errMsg = "Invalid ReasonCode";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.bankCode)) {
        let errMsg = "BankCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.currencyCode)) {
        let errMsg = "CurrencyCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (data.adjustmentAmount == 0) {
        let errMsg = "AdjustmentAmount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidBAData = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidBAData = true;
      this.setState({ isShowAlert: false });
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    return isValidBAData;
  };
  saveBankAdjustment = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let bankAdjustmentData = this.state.bankAdjustmentData;
    let isValidLine = false;
    isValidLine = this.validateBAData(bankAdjustmentData);
    if (isValidLine) {
      if (bankAdjustmentData.isFetched) {
        if (SecurityAccessManager.BankAdjustmentEdit_IsAccessible()) {
          AccountPayableService.updateBankAdjustment(
            bankAdjustmentData,
            this.updateBankAdjustmentResponse,
            this.saveBankAdjustmentError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.BankAdjustmentCreate_IsAccessible()) {
          AccountPayableService.createBankAdjustment(
            bankAdjustmentData,
            this.saveBankAdjustmentResponse,
            this.saveBankAdjustmentError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  saveBankAdjustmentResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
    let bankAdjustmentData = new BankAdjustmentBean();
    let pageTitle = this.moduleCaption;
    if (response.data != null && response.data.bankAdjustmentBean != null) {
      bankAdjustmentData = response.data.bankAdjustmentBean;
      pageTitle = this.moduleCaption + " - EDIT";
    }
    this.setState({
      bankAdjustmentData: bankAdjustmentData,
      pageTitle: pageTitle,
    });
    // this.unLockBankAdjustment(bankAdjustmentData.adjustmentNumber);

    if (!this.isLocked) {
      this.editBankAdjustment(bankAdjustmentData.adjustmentNumber);
    }
  };
  updateBankAdjustmentResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
    let bankAdjustmentData = new BankAdjustmentBean();
    let pageTitle = this.moduleCaption;
    if (response.data != null && response.data.bankAdjustmentBean != null) {
      bankAdjustmentData = response.data.bankAdjustmentBean;
      pageTitle = this.moduleCaption + " - EDIT";
    }
    this.setState({
      bankAdjustmentData: bankAdjustmentData,
      pageTitle: pageTitle,
    });

    if (this.isLocked) {
      this.code = bankAdjustmentData.adjustmentNumber;
      this.unLockBankAdjustment(bankAdjustmentData.adjustmentNumber);
    }
  };
  saveBankAdjustmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("error" + error);
  };
  handleApproveResponse = (response) => {
    let success = false;
    let mainResponseSuccess = false;
    let additionalResponseSuccess = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.mainOperationResponse != null) {
      if (response.mainOperationResponse.errors != null) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        mainResponseSuccess = false;
      }
      if (response.mainOperationResponse.infos != null) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription),
        );
        mainResponseSuccess = true;
        let successMsg = [];
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
        });
      }
    }
    if (response.additionalOperationResponse != null) {
      if (response.additionalOperationResponse.errors != null) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        additionalResponseSuccess = false;
      }
      if (response.additionalOperationResponse.infos != null) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription),
        );
        additionalResponseSuccess = true;
        let successMsg = [];
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
        });
      }
    }
    success = mainResponseSuccess && additionalResponseSuccess;
    return success;
  };
  approveBankAdjustment = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Approving ..",
      });
      let bankAdjustmentData = this.state.bankAdjustmentData;
      let request = new RestBankAdjustmentBeanRequest();
      request.companyCode = this.companyCode;
      request.bankAdjustment = bankAdjustmentData;
      request.isLoadChildren = true;
      let isLockRequired =
        NEW_ENTRY === bankAdjustmentData.adjustmentNumber ? false : true;
      request.isLockRequired = isLockRequired;
      if (bankAdjustmentData.isFetched) {
        if (
          SecurityAccessManager.BankAdjustmentEdit_IsAccessible() &&
          SecurityAccessManager.BankAdjustmentApproval_IsAccessible()
        ) {
          AccountPayableService.updateAndApproveBankAdjustment(
            request,
            this.approveBankAdjustmentResponse,
            this.approveBankAdjustmentError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.BankAdjustmentCreate_IsAccessible() &&
          SecurityAccessManager.BankAdjustmentApproval_IsAccessible()
        ) {
          AccountPayableService.createAndApproveBankAdjustment(
            request,
            this.approveBankAdjustmentResponse,
            this.approveBankAdjustmentError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  approveBankAdjustmentResponse = (response) => {
    this.handleApproveResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.mainOperationResponse) &&
      !isEmpty(response.data.mainOperationResponse.bankAdjustmentBean)
    ) {
      const bankAdjustmentData =
        response.data.mainOperationResponse.bankAdjustmentBean;

      if (bankAdjustmentData != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          bankAdjustmentData: bankAdjustmentData,
          pageTitle: pageTitle,
        });

        this.editBankAdjustment(bankAdjustmentData.adjustmentNumber);
      }
      this.setState({
        isLoading: false,
        loadingText: "",
      });
    }
  };
  approveBankAdjustmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  moduleExit = () => {
    let bankAdjustmentData = this.state.bankAdjustmentData;
    if (bankAdjustmentData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unLockBankAdjustment(bankAdjustmentData.adjustmentNumber);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  getModuleListView = () => {
    let bankAdjustmentData = this.state.bankAdjustmentData;
    if (bankAdjustmentData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadBankAdjustmentList();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unLockBankAdjustment(bankAdjustmentData.adjustmentNumber);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadBankAdjustmentList();
    }
  };
  resetView = () => {
    let bank_Data = this.state.bankAdjustmentData;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode)
        this.unLockBankAdjustment(bank_Data.adjustmentNumber);
    } else {
      this.isLocked = false;
    }

    let bankAdjustmentData = new BankAdjustmentBean();
    this.setState({
      bankAdjustmentData: bankAdjustmentData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isShowLookup: true,
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjReasonList: false,
      bankAdjReasonPageListForAutoCompleteList: new Array(),
      statusTracks: new Array(),
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  getHeaderView() {
    return (
      <BankAdjustmentEntryForm
        {...this.state}
        onChange={this.onChange}
        bankOnChange={this.bankOnChange}
        bankEnterKeyEvent={this.bankEnterKeyEvent}
        displayBankAutoCompleteList={this.displayBankAutoCompleteList}
        adjReasonOnChange={this.adjReasonOnChange}
        adjReasonEnterKeyEvent={this.adjReasonEnterKeyEvent}
        displayAdjReasonAutoCompleteList={this.displayAdjReasonAutoCompleteList}
        moduleCaption={this.moduleCaption}
      />
    );
  }
  getHistoryView() {
    return (
      <BankAdjustmentHistoryDetailsForm
        {...this.state}
        moduleCaption={this.moduleCaption}
        handleSortingStatusHistoryChange={this.handleSortingStatusHistoryChange}
      />
    );
  }
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  save = () => {
    this.saveBankAdjustment();
  };
  onChange = (e) => {
    let temp_bankdata = this.state.bankAdjustmentData;
    temp_bankdata[e.target.name] = e.target.value;
    this.setState({
      bankAdjustmentData: temp_bankdata,
    });
  };
  selectButtonClick = (e) => {
    this.editBankAdjustment(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  listOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria["adjustmentNumberContains"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  bankOnChange = (e) => {
    let bankCode = e.target.value;
    this.state.isShowAutoCompleteBankList = true;
    let tempData = this.state.bankAdjustmentData;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    if (isEmpty(bankCode)) {
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      let tempData = this.state.bankAdjustmentData;
      tempData.bankCode = "";
      tempData.currencyCode = "";

      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        bankAdjustmentData: tempData,
        bankPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "bankCode" &&
      showAutoCompleteList === true &&
      bankCode !== ""
    ) {
      this.readBankBySearchString(e.target.value);
      this.readBank(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ bankAdjustmentData: tempData });
  };
  bankEnterKeyEvent = (e) => {
    this.readBank(e.target.value);
    this.state.isShowAutoCompleteBankList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    this.setState({
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayBankAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteBankList: isShowAutoCompleteList,
    });
  };
  readBankBySearchString = (searchString) => {
    let bankData = this.state.banks;
    let simpleAutoCompleteList = new Array();
    if (bankData.length > 0 && bankData != null) {
      bankData.map((obj) => {
        let bankBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(bankBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      bankPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readBank = (bankCode) => {
    let tempData = this.state.bankAdjustmentData;
    let bankBean = null;
    let bankData = null;
    let currencyCode = "";
    this.state.banks.map((ln) => {
      if (ln.code === bankCode) {
        bankBean = ln;
        bankData = new BaseBean();
        bankData.code = ln.code;
        bankData.description = ln.description;
        currencyCode = ln.currencyCode;
      }
    });
    if (!isEmpty(bankBean)) {
      tempData.bankCode = bankBean.code;
      tempData.currencyCode = currencyCode;
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      this.setState({
        bankAdjustmentData: tempData,
        isShowAutoCompleteBankList: showAutoCompleteList,
      });
    }
  };
  adjReasonOnChange = (e) => {
    let reasonCode = e.target.value;
    this.state.isShowAutoCompleteAdjReasonList = true;
    let tempData = this.state.bankAdjustmentData;
    let showAutoCompleteList = this.state.isShowAutoCompleteAdjReasonList;
    if (isEmpty(reasonCode)) {
      this.state.isShowAutoCompleteAdjReasonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteAdjReasonList;
      let tempData = this.state.bankAdjustmentData;
      tempData.reasonCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        bankAdjustmentData: tempData,
        bankAdjReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "reasonCode" &&
      showAutoCompleteList === true &&
      reasonCode !== ""
    ) {
      this.readAdjReasonBySearchString(e.target.value);
      this.readAdjReason(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ bankAdjustmentData: tempData });
  };
  adjReasonEnterKeyEvent = (e) => {
    this.readAdjReason(e.target.value);
    this.state.isShowAutoCompleteAdjReasonList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteAdjReasonList;
    this.setState({
      bankAdjReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAdjReasonAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteAdjReasonList: isShowAutoCompleteList,
    });
  };
  readAdjReasonBySearchString = (searchString) => {
    let reasonData = this.state.adjustmentReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((obj) => {
        let reasonBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(reasonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      bankAdjReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readAdjReason = (reasonCode) => {
    let tempData = this.state.bankAdjustmentData;
    let reasonBean = null;
    let reasonData = null;
    this.state.adjustmentReasons.map((ln) => {
      if (ln.code === reasonCode) {
        reasonBean = ln;
        reasonData = new BaseBean();
        reasonData.code = ln.code;
        reasonData.description = ln.description;
      }
    });
    if (!isEmpty(reasonBean)) {
      tempData.reasonCode = reasonBean.code;
      this.state.isShowAutoCompleteAdjReasonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteAdjReasonList;
      this.setState({
        bankAdjustmentData: tempData,
        isShowAutoCompleteAdjReasonList: showAutoCompleteList,
      });
    }
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let bankList = this.state.bankList;
    if (sortField && !isEmptyArray(bankList)) {
      const sorted = [...bankList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ bankList: sorted });
    }
  };
  handleSortingStatusHistoryChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingStatusHistory(sortField, sortOrder);
  };
  handleSortingStatusHistory = (sortField, sortOrder) => {
    let list = this.state.statusTracks;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ statusTracks: sorted });
    }
  };
  render() {
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <div>
          <ModuleToolBar
            isShowNewButton={false}
            onNewEntry={() => this.addNewEntry()}
            onModuleExit={() => this.moduleExit()}
            resetView={() => this.resetView()}
            pageTitle={this.state.pageTitle}
            loadingText={this.state.loadingText}
            isLoading={this.state.isLoading}
            isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
            isMaintenanceMode={!this.state.isBankAdjustmentListFormOpen}
            onModuleKeyContainerButtonClick={this.editBankAdjustment}
            moduleKeyCode={this.state.moduleKeyCode}
            onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            getModuleListView={this.getModuleListView}
            lookupRequired={true} //for f2 lookup
            lookupHandler={this.state.bankAdjustmentLookupHandler} //for f2 lookup
            showCriteriaDialog={true} //for f2 lookup
            onModuleKeyCodeWithCriteriaOnChange={
              this.onModuleKeyCodeWithCriteriaOnChange
            }
            selectButtonClick={this.selectButtonClick}
            disabled={this.state.disabled}
            isSpecialViewMode={this.state.isSpecialViewMode}
            isResetView={this.state.isResetView}
          />
        </div>
        {!this.state.isBankAdjustmentListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowApproveButton={this.state.isShowApproveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
              extend_toolbar={
                <>
                  {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approveBankAdjustment(e)}
                    >
                      <ApproveIcon />
                      Approve
                    </Button>
                  )}
                </>
              }
            />
          )}
        {/* <BaseNotification error_list={this.state.error_list} /> */}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedNodeKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={this.state.moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isBankAdjustmentListFormOpen &&
          this.state.isBankAdjustmentEntryFormOpen &&
          !this.state.isBankAdjustmentHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isBankAdjustmentListFormOpen &&
          this.state.isBankAdjustmentEntryFormOpen &&
          !this.state.isBankAdjustmentHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isBankAdjustmentListFormOpen &&
          !this.state.isBankAdjustmentEntryFormOpen &&
          this.state.isBankAdjustmentHistoryFormOpen &&
          this.getHistoryView()}

        {this.state.isBankAdjustmentListFormOpen && (
          <BankAdjustmentListForm
            {...this.state}
            editBankAdjustment={this.editBankAdjustment}
            filterBankAdjustment={this.filterBankAdjustment}
            resetFilterBankAdjustment={this.resetFilterBankAdjustment}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            listOnChange={this.listOnChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
      </div>
    );
  }
}
class BankAdjustmentListForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.listOnChange(e);
  };
  editBankAdjustment = (e, code) => {
    if (e.detail == 1) this.props.editBankAdjustment(code);
  };
  filterBankAdjustment = (e) => {
    if (e.detail == 1) this.props.filterBankAdjustment();
  };
  resetFilterBankAdjustment = (e) => {
    if (e.detail == 1) this.props.resetFilterBankAdjustment();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterBankAdjustment();
    }
  };

  bankAdjustmentPageColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("BankAdjustment#", "adjustmentNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.editBankAdjustment, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BankCode", "bankCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AdjustmentReason", "reasonCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Adjustment Amount", "adjustmentAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCaption),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" Created Date", "createdDate", true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };
  getCaption = (status) => {
    return ModuleUtils.getBankAdjustmentStatusCaption(status);
  };
  render() {
    let bankList = this.props.bankList;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    if (!isEmpty(pageList)) {
      let pageSize = pageList.pageSize;
      let totalCount = pageList.totalCount;
      totalPages = totalCount / pageSize;
      totalPages += totalCount % pageSize == 0 ? 0 : 1;
    }
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="adjustmentNumberContains"
                type="text"
                value={criteria.adjustmentNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>
            <Button onClick={(e) => this.filterBankAdjustment(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button onClick={(e) => this.resetFilterBankAdjustment(e)}>
              Reset
            </Button>
          </div>

          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>

            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="mt-3">
          <CustomTable
            data={bankList}
            columns={this.bankAdjustmentPageColumns()}
            enableHighlight={true} // Boolean flag controlling highlight execution
            //  searchText={pickTicketCriteria.searchName} // Search input text
          />
        </div>
      </div>
    );
  }
}
class BankAdjustmentEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.adjustmentReasonRef = React.createRef();
    this.bankCodeRef = React.createRef();
    this.state = {
      bankAdjustmentData: this.props.bankAdjustmentData,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let adjustmentReasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.adjustmentReasons,
      "Adjustment Reason",
    );
    this.setState({
      adjustmentReasonLookupHandler: adjustmentReasonLookupHandler,
    });
    let bankCodeLookupHandler = new GenericAttributeLookupHandler(
      this.props.banks,
      "BankCode",
    );
    this.setState({ bankCodeLookupHandler: bankCodeLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  bankOnChange = (e) => {
    this.props.bankOnChange(e);
  };
  bankEnterKeyEvent = (e) => {
    this.props.bankEnterKeyEvent(e);
  };
  /**
   *
   * @param {boolean} showAutoCompleteList
   * return boolean
   */
  displayBankAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayBankAutoCompleteList(showAutoCompleteList);
  };
  adjReasonOnChange = (e) => {
    this.props.adjReasonOnChange(e);
  };
  adjReasonEnterKeyEvent = (e) => {
    this.props.adjReasonEnterKeyEvent(e);
  };
  /**
   *
   * @param {boolean} showAutoCompleteList
   * return boolean
   */
  displayAdjReasonAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayAdjReasonAutoCompleteList(showAutoCompleteList);
  };
  render() {
    let bankAdjustmentData = this.props.bankAdjustmentData;
    let isAmountDisable = false;
    if (bankAdjustmentData.status == "A") {
      isAmountDisable = true;
    }
    return (
      <div>
        <Row>
          <Col sm="1">
            <FormLabel> Created Date</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <DatePickerComponent
              name="createdDate"
              value={bankAdjustmentData.createdDate}
              disabled={true}
              onChange={this.onChange}
            />
          </Col>
          <Col sm="1">
            <FormLabel> AdjustmentReason</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              ref={this.adjustmentReasonRef}
              onChange={this.adjReasonOnChange}
              placeholder="reasonCode"
              name="reasonCode"
              value={bankAdjustmentData.reasonCode}
              lookupRequired={this.props.isShowLookup}
              lookupHandler={this.state.adjustmentReasonLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.adjReasonEnterKeyEvent}
              autoCompleteListData={
                this.props.bankAdjReasonPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAdjReasonAutoCompleteList}
              showAutoCompleteList={this.props.isShowAutoCompleteAdjReasonList}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel> BankCode</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              onChange={this.bankOnChange}
              placeholder="bankCode"
              name="bankCode"
              value={bankAdjustmentData.bankCode}
              lookupRequired={this.props.isShowLookup}
              lookupHandler={this.state.bankCodeLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.bankEnterKeyEvent}
              autoCompleteListData={this.props.bankPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayBankAutoCompleteList}
              showAutoCompleteList={this.props.isShowAutoCompleteBankList}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel> Currency</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              onChange={this.onChange}
              name="currencyCode"
              value={bankAdjustmentData.currencyCode}
              disabled={true}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>AdjustmentAmount</FormLabel>
          </Col>
          <Col sm="3">
            <NumberFormatInputbox
              onChange={this.onChange}
              name="adjustmentAmount"
              value={bankAdjustmentData.adjustmentAmount}
              className="summary_input text-end"
              decimalScale={2}
              disabled={isAmountDisable}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
class BankAdjustmentHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  handleSortingStatusHistoryChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingStatusHistoryChange(accessor);
  };
  render() {
    let statusTracks = this.props.statusTracks;
    return (
      <div className="header_div">
        <div className="div_Custom_3">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusHistoryChange(e, "createdDate")
                  }
                >
                  Date{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusHistoryChange(e, "currentStatus")
                  }
                >
                  Status{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "currentStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusHistoryChange(e, "previousStatus")
                  }
                >
                  PreviousStatus{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "previousStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusHistoryChange(e, "createdBy")
                  }
                >
                  DoneBy{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdBy" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {statusTracks != null ? (
              <tbody>
                {statusTracks.map((ln, index) => (
                  <tr key={index}>
                    <td>{ln.createdDate}</td>
                    <td>
                      {ModuleUtils.getBankAdjustmentStatusCaption(
                        ln.currentStatus,
                      )}
                    </td>
                    <td>
                      {ModuleUtils.getBankAdjustmentStatusCaption(
                        ln.previousStatus,
                      )}
                    </td>
                    <td>{ln.createdBy}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {statusTracks.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
function BankAdjustmentModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <BankAdjustmentList {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default BankAdjustmentModule;
